import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "../ui/button";
import { Section } from "./section";
export function PageCta() {
    return (<Section className="surface-ink">
      <div className="flex flex-col items-center justify-between gap-6 rounded-3xl border border-ink-foreground/10 bg-ink-foreground/5 p-8 md:flex-row md:px-10 md:py-8">
        <div>
          <h3 className="text-xl font-bold md:text-2xl">Start monitoring your portfolio today.</h3>
          <p className="mt-2 max-w-md text-sm opacity-70">
            Sign up free or search an address to see how Violerts tracks violations, permits and agency data.
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button asChild variant="signal" size="lg">
            <Link to="/sign-up">Sign up now</Link>
          </Button>
          <Button asChild variant="onInk" size="lg">
            <Link to="/?focus=address">
              <Search className="h-4 w-4"/>
              Search an address
            </Link>
          </Button>
        </div>
      </div>
    </Section>);
}
